<template>
  <div class="pa-2">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.name.text"
          append-icon="mdi-domain"
          clear-icon="mdi-close-circle-outline"
          clearable
          counter="50"
          dense
          hint="لطفا نام مجموعه خود را وارد کنید."
          label="نام مجموعه "
          maxLength="50"
          outlined
          class="contentinfo"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.labelName.text"
          append-icon="mdi-basket"
          clear-icon="mdi-close-circle-outline"
          clearable
          counter="50"
          dense
          hint="لطفا نام محصول خود را وارد کنید."
          label="نام محصول "
          maxLength="50"
          outlined
          class="contentinfo"
        />
      </v-col>
      <v-col cols="12" md="6" class="d-flex align-items-start">
        <price-input
          dense
          clearable
          label="قیمت تولید "
          v-model="valueComputed.price.text"
          type="number"
          text-center="true"
        ></price-input>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="d-flex align-center"
              v-on="on"
              v-bind="attrs"
              style="cursor: pointer"
            >
              <v-checkbox
                v-model="valueComputed.price.line"
                hide-details
                class="ma-0 pa-0"
                dense
                style="height: 20px; width: 20px"
                @click.stop
              ></v-checkbox>
            </div>
          </template>
          <span>
            {{
              valueComputed.price.line
                ? "خط جداکننده غیر فعال شود"
                : "خط جدا کننده فعال شود"
            }}
          </span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" md="6" class="d-flex align-items-start">
        <price-input
          dense
          clearable
          label=" قیمت مصرف کننده "
          v-model="valueComputed.bPrice.text"
          type="number"
          text-center="true"
        ></price-input>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="d-flex align-center"
              v-on="on"
              v-bind="attrs"
              style="cursor: pointer"
            >
              <v-checkbox
                v-model="valueComputed.bPrice.line"
                hide-details
                class="ma-0 pa-0"
                dense
                style="height: 20px; width: 20px"
                @click.stop
              ></v-checkbox>
            </div>
          </template>
          <span>
            {{
              valueComputed.bPrice.line
                ? "خط جداکننده غیر فعال شود"
                : "خط جدا کننده فعال شود"
            }}
          </span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" md="6" class="d-flex align-items-start">
        <price-input
          dense
          clearable
          label="قیمت خرید مشتری"
          v-model="valueComputed.cPrice.text"
          type="number"
          text-center="true"
        ></price-input>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="d-flex align-center"
              v-on="on"
              v-bind="attrs"
              style="cursor: pointer"
            >
              <v-checkbox
                v-model="valueComputed.cPrice.line"
                hide-details
                class="ma-0 pa-0"
                dense
                style="height: 20px; width: 20px"
                @click.stop
              ></v-checkbox>
            </div>
          </template>
          <span>
            {{
              valueComputed.cPrice.line
                ? "خط جداکننده غیر فعال شود"
                : "خط جدا کننده فعال شود"
            }}
          </span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.discount.text"
          append-icon="mdi-sale"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hint="لطفا  در تخفیف خود را وارد کنید."
          label="تخفیف محصول  "
          type="number"
          :rules="[
            (v) =>
              (v <= 100 && v >= 0) ||
              'مقدار نمیتواند از ۱۰۰ بزرگتر و از ۰ کوچکتر باشد',
          ]"
          outlined
          class="contentinfo"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.discount.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.discount.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
      <v-col class="d-flex align-items-start" cols="12" md="6">
        <custom-date-picker
          v-model="valueComputed.production.text"
          label="تاریخ تولید"
          outlined
          input-class="date-end"
          dense
          append-icon="mdi-calendar-month"
        />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="d-flex align-center"
              v-on="on"
              v-bind="attrs"
              style="cursor: pointer"
            >
              <v-checkbox
                v-model="valueComputed.production.line"
                hide-details
                class="ma-0 pa-0"
                dense
                style="height: 20px; width: 20px"
                @click.stop
              ></v-checkbox>
            </div>
          </template>
          <span>
            {{
              valueComputed.production.line
                ? "خط جداکننده غیر فعال شود"
                : "خط جدا کننده فعال شود"
            }}
          </span>
        </v-tooltip>
      </v-col>
      <v-col class="d-flex align-items-start" cols="12" md="6">
        <custom-date-picker
          v-model="valueComputed.expiration.text"
          label="تاریخ انقضا"
          outlined
          dense
          append-icon="mdi-calendar-month"
          :min="nowDateTimeString()"
        />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="d-flex align-center"
              v-on="on"
              v-bind="attrs"
              style="cursor: pointer"
            >
              <v-checkbox
                v-model="valueComputed.expiration.line"
                hide-details
                class="ma-0 pa-0"
                dense
                style="height: 20px; width: 20px"
                @click.stop
              ></v-checkbox>
            </div>
          </template>
          <span>
            {{
              valueComputed.expiration.line
                ? "خط جداکننده غیر فعال شود"
                : "خط جدا کننده فعال شود"
            }}
          </span>
        </v-tooltip>
      </v-col>

      <!-- <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.weigth.text"
          append-icon="mdi-weight"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hint="لطفا وزن محصول خود را وارد کنید."
          label="وزن محصول "
          type="number"
          outlined
          class="contentinfo"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.weigth.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.weigth.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.size.text"
          append-icon="mdi-arrow-split-vertical"
          clear-icon="mdi-close-circle-outline"
          clearable
          counter="50"
          dense
          hint="لطفا سایز محصول خود را وارد کنید."
          label="سایز محصول "
          outlined
          class="contentinfo"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.size.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.size.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.model.text"
          append-icon="mdi-apps"
          clear-icon="mdi-close-circle-outline"
          clearable
          counter="50"
          dense
          hint="لطفا مدل محصول خود را وارد کنید."
          label="مدل محصول "
          maxLength="50"
          outlined
          class="contentinfo"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.model.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.model.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.series.text"
          append-icon="mdi-briefcase-download"
          clear-icon="mdi-close-circle-outline"
          clearable
          counter="50"
          dense
          hint="لطفا سری ساخت محصول خود را وارد کنید."
          label="سری ساخت محصول "
          maxLength="50"
          outlined
          class="contentinfo"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.series.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.series.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.country.text"
          append-icon="mdi-flag"
          clear-icon="mdi-close-circle-outline"
          clearable
          counter="50"
          dense
          hint="لطفا کشور ساخت محصول خود را وارد کنید."
          label="کشور ساخت محصول "
          maxLength="50"
          outlined
          class="contentinfo"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.country.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.country.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.producer.text"
          append-icon="mdi-office-building-cog"
          clear-icon="mdi-close-circle-outline"
          clearable
          counter="50"
          dense
          hint="لطفا  نام تولید کننده محصول خود را وارد کنید."
          label=" نام تولید کننده محصول "
          maxLength="50"
          outlined
          class="contentinfo"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.producer.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.producer.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="valueComputed.brand.text"
          append-icon="mdi-basket-check"
          clear-icon="mdi-close-circle-outline"
          clearable
          counter="50"
          dense
          hint="لطفا برند محصول خود را وارد کنید."
          label="برند  محصول "
          maxLength="50"
          outlined
          class="contentinfo"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.brand.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.brand.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col> -->

      <v-col cols="12">
        <v-textarea
          v-model="valueComputed.discriptions.text"
          append-icon="mdi-text-box-edit"
          clear-icon="mdi-close-circle-outline"
          clearable
          counter="2000"
          dense
          hint="لطفا توضیحات محصول خود را وارد کنید."
          label="درباره  محصول "
          maxLength="2000"
          outlined
          class="contentinfo"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.discriptions.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.discriptions.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-textarea>
      </v-col>
    </v-row>

    <v-card-title> اطلاعات بیشتر خود را وارد کنید </v-card-title>

    <extra-fields-gold v-model="test" block />
  </div>
</template>

<script>
import customDatePicker from "../../../../core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";
import ExtraFieldsGold from "../../goldLabel/components/extraFieldsGold.vue";
import priceInput from "../../uiBeautifier/priceInput.vue";

export default {
  name: "factoryLabel",

  components: {
    customDatePicker,
    priceInput,
    ExtraFieldsGold,
  },

  props: {
    value: {},
  },

  data() {
    return {
      test: [],
      activeDatePicker: null,
      helpData: [],
      serviceName: "Qrland",
      componentName: "factory-info",
      cons: {
        title: "انتخاب آدرس روی نقشه",
      },
      extraLink: [],
      searchTitle: "",
      showMap: false,
      geom: "",
      suggests: {},
      fieldsInclude: ["qr.cardVisit", "qr.id.edit", "qr.name.edit","qr.name.id.edit", "qr.create.models"],
      mapLoading: false,
      urlRules: [
        (value) =>
          this.isURL(value) ||
          "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
      ],
      apiKey:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      province: [],
      city: [],
      zoomMap: 15,
      geoLocation: {
        city: undefined,
        province: undefined,
      },
      phoneNumberText: [],
      showCompanyNumberName: false,
    };
  },
  computed: {
    getCenter() {
      return this.data.center ?? [51.420296, 35.732379];
    },
    containFields() {
      return this.fieldsInclude.includes(this.$route.name);
    },
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    geom: function (val) {
      this.getBySearch();
    },
    showMap(val) {
      if (val) {
        if (!this.data.coordinates || this.data.coordinates.length <= 0)
          this.data.coordinates = this.getCenter;
      }
    },
    geoLocation: {
      handler(val) {
        if (Object.keys(val.province).length > 0) {
          this.data.coordinates[1] = val.province.longitude;
          this.data.coordinates[0] = val.province.latitude;
          this.getlatLng({
            actualEvent: {
              lngLat: {
                lng: this.data.coordinates[1],
                lat: this.data.coordinates[0],
              },
            },
          });
          this.zoomMap = 13;
        }
      },
      deep: true,
    },
    test: {
      deep: true,
      handler(val) {
        if (!!val) {
          this.$emit("input", {
                  ...this.value,
                  more: val,
                });      
            }
      },
    },
  },

  methods: {
     closeOtherDatePicker(currentPicker) {
      if (this.activeDatePicker && this.activeDatePicker !== currentPicker) {
        this.activeDatePicker = null;
      }
      this.activeDatePicker = currentPicker;
    },
    isURL(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      if (
        !str ||
        regex.test(str) ||
        without_regex.test(str) ||
        str.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    search() {
      this.mapLoading = true;
      axios({
        method: "GET",
        baseURL: "https://map.ir/search/v2",
        params: { text: this.searchTitle },
        timeout: 15000,
        headers: {
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.mapLoading = false;
          this.suggests = response.data.value;
          this.data.center = response.data.value.coordinates;
        })
        .finally(() => {
          this.mapLoading = false;
        });
    },
    getlatLng(e) {
      this.mapLoading = true;
      this.data.coordinates = Object.values(e.actualEvent.lngLat);

      axios({
        method: "GET",
        baseURL: "https://map.ir/reverse",
        params: {
          lat: this.data.coordinates[1],
          lon: this.data.coordinates[0],
        },
        timeout: 15000,
        headers: {
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.mapLoading = false;
          this.data.address = response.data.address;
        })
        .finally(() => {
          this.mapLoading = false;
        });
    },
    getBySearch() {
      this.mapLoading = true;
      this.data.coordinates = this.geom.coordinates;

      axios({
        method: "GET",
        baseURL: "https://map.ir/reverse",
        params: {
          lat: this.data.coordinates[1],
          lon: this.data.coordinates[0],
        },
        timeout: 15000,
        headers: {
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.mapLoading = false;
          this.data.address = response.data.address;
        })
        .finally(() => {
          this.mapLoading = false;
        });
    },
    addPhone() {
      this.data.phoneNumber.push({
        number: "",
      });
    },
    removePhone(index) {
      if (this.data.phoneNumber.length == 1) {
        this.data.phoneNumber[0].number = "";
      } else console.log(this.data.phoneNumber.splice(index, 1));
    },
    addExtra() {
      this.data.extraFields.push({
        icon: "",
        name: "",
        value: "",
      });
    },
    removeExtra(index) {
      if (this.data.extraFields.length <= 1) {
        this.data.extraFields[0] = {
          icon: "",
          name: "",
          value: "",
        };
      } else {
        this.data.extraFields.splice(index, 1);
      }
    },
    removeLocation() {
      this.data.coordinates = null;
    },
    addExtraLink(index, state) {
      if (!this.extraLink[index] || !this.extraLink[index].state) {
        this.extraLink[index] = { state: true };
      } else this.extraLink[index].state = false;
      this.$forceUpdate();
    },
    showPhoneNumberText(index) {
      if (this.phoneNumberText.includes(index)) {
        let i = this.phoneNumberText.indexOf(index);
        this.phoneNumberText.splice(i, 1);
      } else this.phoneNumberText.push(index);
    },
  },

  mounted() {
    let mores = [];

  if (!this.value || !this.value.hasOwnProperty("more")) {
      mores = [];
    } else if (Array.isArray(this.value.more)) {
      mores = this.value.more;
    } else if (
      typeof this.value.more === "object" &&
      this.value.more !== null
    ) {
      mores = Object.values(this.value.more);
    }

  this.$emit("input", {
    ...this.value,
    more: mores,
  });

    this.test = mores;
  },
};
</script>

<style scoped></style>
